import {apiClient} from 'common/util/api-client';
import {Cohort} from 'common/query-builder/cohorts-query-builder/models/cohort';

import {queryApiUrl} from '../utils';

export async function fetchPeopleCountByCohort(
  cohort: Cohort,
  includeAllUsers: boolean,
  dataGroupId,
  {projectId, workspaceId},
) {
  const reqBody = {
    filter_by_cohort: JSON.stringify({raw_cohort: cohort.serialize()}),
    workspace_id: workspaceId,
    project_id: projectId,
    ...(dataGroupId ? {data_group_id: dataGroupId} : {}),
    include_all_users: includeAllUsers,
  };
  //need to change the API endpoint for this so
  //that we can use apiClient.post for response processing
  // eslint-disable-next-line local-rules/deprecated-member-access
  const response = await apiClient.fetch(queryApiUrl(`engage/stats`), {
    method: `POST`,
    body: JSON.stringify(reqBody),
  });
  const responseJson = await response.json();
  return responseJson.results;
}
